import React from 'react';
import {percentageFormat} from "../../helpers/toolbox";

const NpiDisplayPercentage = ({value, fractionDigits=0}:{value: number, fractionDigits?:number}) => {
    return <span>{percentageFormat(value, fractionDigits)}</span>;
};

export default NpiDisplayPercentage;